const STORAGE_PREFIX = 'ov_session_';

const getStorageKey = (name) => `${STORAGE_PREFIX}${name}`;

const readStoredValue = (name) => {
  try {
    const raw = localStorage.getItem(getStorageKey(name));
    if (!raw) return null;

    const parsed = JSON.parse(raw);
    if (parsed?.expiresAt && Date.now() > parsed.expiresAt) {
      localStorage.removeItem(getStorageKey(name));
      return null;
    }

    const value = parsed?.value ?? null;
    if (name === 'userData' && value && typeof value === 'object') {
      const selectedTenantId = (value.selectedTenantId || value.tenantId || '').trim();
      return {
        ...value,
        tenantId: selectedTenantId,
        selectedTenantId,
      };
    }

    return value;
  } catch (error) {
    console.warn(`Unable to read stored session value for ${name}:`, error);
    return null;
  }
};

const writeStoredValue = (name, value, expiresAt) => {
  try {
    localStorage.setItem(
      getStorageKey(name),
      JSON.stringify({ value, expiresAt })
    );
  } catch (error) {
    console.warn(`Unable to persist stored session value for ${name}:`, error);
  }
};

// Kept as compatibility wrappers for the existing codebase.
export const setCookie = (name, value, days = 7) => {
  const expiresAt = Date.now() + days * 24 * 60 * 60 * 1000;
  writeStoredValue(name, value, expiresAt);
};

export const getCookie = (name) => readStoredValue(name);

export const removeCookie = (name) => {
  try {
    localStorage.removeItem(getStorageKey(name));
  } catch (error) {
    console.warn(`Unable to clear stored session value for ${name}:`, error);
  }
};

export const clearAllCookies = () => {
  try {
    Object.keys(localStorage)
      .filter((key) => key.startsWith(STORAGE_PREFIX))
      .forEach((key) => localStorage.removeItem(key));
  } catch (error) {
    console.warn('Unable to clear stored session values:', error);
  }
};
